import { render, staticRenderFns } from "./RegistroLoc.vue?vue&type=template&id=5f1de4e2"
import script from "./RegistroLoc.vue?vue&type=script&lang=js"
export * from "./RegistroLoc.vue?vue&type=script&lang=js"
import style0 from "./RegistroLoc.vue?vue&type=style&index=0&id=5f1de4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports